import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { NAV_MENU_ITEMS } from "./nav-menu.constant";
import { CommonDataService } from "@shared/services/common-data.service";


@Component({
  selector: "app-nav-menu",
  templateUrl: "./nav-menu.component.html",
  styleUrls: ["./nav-menu.component.scss"],
})
export class NavMenuComponent implements OnInit {
  menuItems: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    public router: Router,
    private commonDataService: CommonDataService
  ) { }

  ngOnInit() {
    this.menuItems = NAV_MENU_ITEMS;
    this.getFundDetails();
  }

  closePop() {
    this.activeModal.close();
  }

  navPage = () => {
    this.activeModal.close();
  };

  getFundDetails() {
    const nfoMenu = this.menuItems.find((i) => i.displayName === "NFO");
    this.commonDataService.isNFOActive().subscribe({
      next: (isAccessible) => {
        nfoMenu.disabled = !isAccessible;
      },
      error: () => {
        nfoMenu.disabled = true;
      }
    });
  }

  accountStatements = () => {
    window.open("https://mfs.kfintech.com/investor/General/StatementsAndReports", "_blank");
  };
}
